import './App.css';
import { HashRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import TopBar from './components/TopBar';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import WhereWeAre from './pages/WhereWeAre';
import AboutUs from './pages/AboutUs';
import Contact from './pages/Contact';
import PracticeAreas from './pages/PracticeAreas';
import TermsAndConditions from './pages/TermsAndConditions';
import FreeLegalAid from './pages/FreeLegalAid';
import Mediation from './pages/Mediation';
import Privacy from './pages/Privacy';

// Stare poti, ki so bile v obtoku pred poenotenjem na slovenska imena.
// Ohranjene, da obstojece povezave in zadetki v iskalnikih ne crknejo.
const LEGACY_ROUTES = {
  '/practice-areas': '/podrocja-dela',
  '/cenik': '/splosni-pogoji',
  '/about': '/kje-smo',
  '/contact': '/kontakt',
};

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function AppContent() {
  const { pathname } = useLocation();

  return (
    <>
      <ScrollToTop />
      <TopBar />
      <Header />

      <main className="container">
        <div key={pathname} className="page-enter">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/podrocja-dela" element={<PracticeAreas />} />
            <Route path="/splosni-pogoji" element={<TermsAndConditions />} />
            <Route path="/brezplacna-pravna-pomoc" element={<FreeLegalAid />} />
            <Route path="/mediacija" element={<Mediation />} />
            <Route path="/o-nas" element={<AboutUs />} />
            <Route path="/kje-smo" element={<WhereWeAre />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/zasebnost" element={<Privacy />} />

            {Object.entries(LEGACY_ROUTES).map(([from, to]) => (
              <Route key={from} path={from} element={<Navigate to={to} replace />} />
            ))}

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </main>

      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <HashRouter>
        <AppContent />
      </HashRouter>
    </div>
  );
}

export default App;
